import { render, staticRenderFns } from "./dialogMyReser.vue?vue&type=template&id=2d0a836a&scoped=true&"
import script from "./dialogMyReser.vue?vue&type=script&lang=js&"
export * from "./dialogMyReser.vue?vue&type=script&lang=js&"
import style0 from "./dialogMyReser.vue?vue&type=style&index=0&id=2d0a836a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a836a",
  null
  
)

export default component.exports